import { CellInfo } from 'react-table';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { ListTable } from '../../../../components';
import { useActionDispatcher } from '../../../../hooks';
import {
  getOrderListRequest,
  setOrderListDirty,
} from '../../../../store/modules/orders/actions';
import { selectOrderList } from '../../../../store/modules/orders/selectors';
import AdvancedActionCell from '../../../../components/action-cell/AdvancedActionCell';

const ProjectOrdersTable = () => {
  const { loading, data, dirty } = useSelector(selectOrderList);
  const { id: projectId } = useParams<{id: string}>();
  const requiredFilters = useMemo(() => [{ key: 'project_id', value: projectId }], [projectId]);
  const getList = useActionDispatcher(getOrderListRequest);
  const setDirty = useActionDispatcher(setOrderListDirty);

  return (
    <ListTable
      columns={[
        {
          id: 'title',
          Header: 'Order Title',
          minWidth: 80,
        },
        {
          id: 'ref.assigned_to.full_name_first_last',
          Header: 'Assigned to',
          minWidth: 80,
        },
        {
          id: 'ref.status.description',
          Header: 'Order Status',
          minWidth: 80,
        },
        {
          id: 'ref.created_age',
          Header: 'Order Created',
          minWidth: 60,
          maxWidth: 140,
        },
        {
          id: 'ref.first_edit_delivery.description',
          Header: 'First Edit',
          minWidth: 80,
        },
        {
          id: 'actions',
          accessor: 'id',
          Cell: (cell: CellInfo) => (
            <AdvancedActionCell zIndex={2147483099}>
              {

              }
            </AdvancedActionCell>
          ),
          width: 65,
        },
      ]}
      loading={loading}
      data={data}
      fetch={getList}
      requiredFilters={requiredFilters}
      dirty={Boolean(dirty)}
      setDirty={setDirty}
      hideFilters
      hideAddButton
      viewEnable
    />
  );
};

export default ProjectOrdersTable;
